import type { currencyConversion } from '~/schema/public';
import getGameLanguage from './getGameLanguage';
import type { GameQueryVariables } from '../GameQuery.generated';

type Args = {
  site: Site;
  locale: string;
  featureFlags?: FeatureFlags;
  currentUser?: CurrentUser;
  category: string;
  handle: string;
};

const getGameQueryVariables = ({
  site,
  locale,
  featureFlags,
  currentUser,
  category,
  handle,
}: Args): GameQueryVariables => {
  const { walletCurrency, profile } = currentUser ?? {};
  const currency = (walletCurrency as currencyConversion) ?? 'BTC';
  const language = getGameLanguage(locale, featureFlags, profile);
  return {
    language,
    currency,
    gameFilter: { handle, site, currency, menuItem: category },
    descFilter: { site, language, section: 'games', handle },
  };
};

export default getGameQueryVariables;
